import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import styles from './GameShowcaseBanner.module.css'

const DISMISS_KEY = 'gameShowcaseBannerDismissed'

const GameShowcaseBanner = ({ site, onSubmit }) => {
  const [dismissed, setDismissed] = useState(() => {
    if (typeof window === 'undefined') return false
    return sessionStorage.getItem(DISMISS_KEY) === 'true'
  })

  if (!site || dismissed) return null

  const handleClose = (e) => {
    e.preventDefault()
    e.stopPropagation()
    sessionStorage.setItem(DISMISS_KEY, 'true')
    setDismissed(true)
  }

  const handleSubmit = () => {
    onSubmit?.(site)
  }

  return (
    <div className={styles.bannerContainer} onClick={handleSubmit} role="button" tabIndex={0}>
      <div className={styles.bannerContent}>
        <button type="button" className={styles.closeButton} onClick={handleClose} aria-label="Dismiss banner">
          <img src="/assets/icons/cancel_white.svg" height="15" width="15" alt="cancel" />
        </button>

        <div className={styles.contentWrapper}>
          <div className={styles.iconSection}>
            <i className={`bi bi-controller ${styles.icon}`} />
          </div>
          <div className={styles.textSection}>
            <h4 className={styles.title}>Your game is live! Share it with the world.</h4>
            <p className={styles.subtitle}>
              Add your game to our showcase and share it with Tiiny Host's 2 million users.
            </p>
          </div>

          <div className={styles.buttonSection}>
            <Button variant="outline-light" className={styles.submitButton}>
              Submit Game
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GameShowcaseBanner
